import { useEffect } from 'react'

import { PasswordRecoveryPanel } from '../../components/panels'

/**
 *
 * Renders the PasswordRecoveryPanel component and sets the document title to 'Recuperar Senha | LCD' using the useEffect hook.
 * 
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered PasswordRecoveryPanel component.
 */
const PasswordRecoveryPage = () => {

    useEffect(() => {
        document.title = 'Recuperar Senha | LCD'
    }, [])

    return (
        <PasswordRecoveryPanel />
    )
}

export default PasswordRecoveryPage